const colorSwitchElements = document.querySelectorAll('.color-switch');

colorSwitchElements.forEach(colorSwitch => {
    const options = colorSwitch.querySelectorAll('.color-switch-option');
    const images = colorSwitch.querySelectorAll('.color-switch-vehicle-image');
    const allColorNames = colorSwitch.querySelectorAll('.color-switch-color-name');

    if (options.length > 0) {
        options[0].classList.add('active');
    }
    if (images.length > 0) {
        images[0].classList.add('active');
    }

    const firstColorNames = colorSwitch.querySelectorAll('[data-color-name="1"]');
    firstColorNames.forEach(name => name.classList.add('active'));

    options.forEach(option => {
        const handleActivation = () => {
            const colorIndex = option.dataset.color;

            options.forEach(opt => opt.classList.remove('active'));
            images.forEach(img => img.classList.remove('active'));
            allColorNames.forEach(name => name.classList.remove('active'));

            option.classList.add('active');

            const targetImage = colorSwitch.querySelector(`[data-image="image-${colorIndex}"]`);
            if (targetImage) {
                targetImage.classList.add('active');
            }

            const targetColorNames = colorSwitch.querySelectorAll(`[data-color-name="${colorIndex}"]`);
            targetColorNames.forEach(name => name.classList.add('active'));
        };

        option.addEventListener('click', handleActivation);

        option.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleActivation();
            }
        });
    });
});
